import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useSettings } from "@/context/SettingsContext";

export default function CookieConsent() {
  const [show, setShow] = useState(false);
  const { refresh } = useSettings();

  useEffect(() => {
    if (!localStorage.getItem("nsa_cookie_consent")) setShow(true);
  }, []);

  const decide = (value) => {
    localStorage.setItem("nsa_cookie_consent", value);
    setShow(false);
    if (value === "accepted") refresh();
  };

  if (!show) return null;
  return (
    <div className="fixed bottom-[88px] lg:bottom-4 left-4 right-4 sm:right-auto sm:max-w-md z-50 bg-white border border-slate-200 rounded-2xl shadow-xl p-5" data-testid="cookie-consent">
      <div className="flex gap-3">
        <Cookie className="w-6 h-6 text-primary shrink-0" strokeWidth={1.5} />
        <div>
          <p className="text-sm text-slate-700 leading-relaxed">
            We use essential cookies to run this site and optional analytics cookies to improve it. You can accept or reject non-essential cookies.{" "}
            <Link to="/cookie-policy" className="text-primary underline">Learn more</Link>.
          </p>
          <div className="mt-4 flex gap-2">
            <Button size="sm" className="rounded-full" onClick={() => decide("accepted")} data-testid="cookie-accept">Accept all</Button>
            <Button size="sm" variant="outline" className="rounded-full" onClick={() => decide("rejected")} data-testid="cookie-reject">Reject non-essential</Button>
          </div>
        </div>
      </div>
    </div>
  );
}
